module.exports = __webpack_public_path__ + "static/media/potato-fry.9878e3a5.jpg";